import { defineMessages } from "react-intl";

export const messages = defineMessages({
    migrationTicketsListStatusToDo: {
        id: "fastshift.dashboard.migration-tickets-list.status.to-do",
        defaultMessage: "TO DO",
        description: "Status label for TO_DO status"
    },
    migrationTicketsListStatusOnTrack: {
        id: "fastshift.dashboard.migration-tickets-list.status.on-track",
        defaultMessage: "ON TRACK",
        description: "Status label for ON_TRACK status"
    },
    migrationTicketsListStatusComplete: {
        id: "fastshift.dashboard.migration-tickets-list.status.complete",
        defaultMessage: "COMPLETED",
        description: "Status label for COMPLETE status"
    },
    migrationTicketsListStatusAtRiskAtlassianOwned: {
        id: "fastshift.dashboard.migration-tickets-list.status.at-risk-atlassian-owned",
        defaultMessage: "AT RISK - OWNED BY ATLASSIAN",
        description: "Status label for AT_RISK_ATLASSIAN_OWNED status"
    },
    migrationTicketsListStatusAtRiskPartnerOwned: {
        id: "fastshift.dashboard.migration-tickets-list.status.at-risk-partner-owned",
        defaultMessage: "AT RISK - OWNED BY PARTNER",
        description: "Status label for AT_RISK_PARTNER_OWNED status"
    },
    migrationTicketsListStatusNeedsCustomerAttention: {
        id: "fastshift.dashboard.migration-tickets-list.status.needs-customer-attention",
        defaultMessage: "NEEDS CUSTOMER ATTENTION",
        description: "Status label for NEEDS_CUSTOMER_ATTENTION status"
    },
    migrationTicketsListStatusUnknown: {
        id: "fastshift.dashboard.migration-tickets-list.status.unknown",
        defaultMessage: "UNKNOWN STATUS",
        description:
            "Fallback status label for unknown status values to prevent UI crashes"
    }
});
